import { z } from 'zod';

export const certificationRowSchema = z.object({
  id: z.string().min(1),
  name: z.string().min(1),
  issuer: z.string().min(1),
  year: z.string().nullable(),
  description: z.string(),
  iconName: z.string(),
  highlight: z.boolean(),
  image: z.string().nullable(),
  link: z.string().nullable(),
  sortOrder: z.number().int(),
  visible: z.boolean(),
});

export const certificationInsertSchema = z.object({
  id: z.string().min(1).optional(),
  name: z.string().min(1),
  issuer: z.string().min(1),
  year: z.string().nullable().optional(),
  description: z.string().optional(),
  iconName: z.string().optional(),
  highlight: z.boolean().optional(),
  image: z.string().nullable().optional(),
  link: z.string().nullable().optional(),
  sortOrder: z.number().int().optional(),
  visible: z.boolean().optional(),
});

export const certificationUpdateSchema = certificationInsertSchema.partial();

export type CertificationRow = z.infer<typeof certificationRowSchema>;
export type CertificationInsert = z.input<typeof certificationInsertSchema>;
export type CertificationUpdate = z.input<typeof certificationUpdateSchema>;
